<template>
  <h1
    class="choice-title"
    v-if="$store.getters?.getQuesInfo?.type === 1 && data?.isRequired"
    :class="{
      required: $store.getters?.getQuesInfo?.type === 1 && data?.isRequired,
    }"
  >
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span
    >{{ data?.title }}
  </h1>
  <h1 class="choice-title" v-else :class="{ required: showAnswerRequired }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span
    >{{ data?.title }}
  </h1>
  <div class="citys choice" @click="handleShowClick">
    <div v-if="!isReview" class="choice-item content-wrap">
      <p>{{ checkedValue }}</p>
      <div class="san"></div>
    </div>
    <div v-else class="choice-item review">
      {{ value }}
    </div>
  </div>
  <Popup class="popup" v-model:show="show" position="bottom">
    <div
      v-for="(item, index) in data?.optionVoList"
      :key="index"
      @click="handleChoseClick(item)"
      class="select-item"
      :class="{
        disabled:
          $store.getters?.getQuesInfo?.type === 1 && item.display === false,
      }"
    >
      {{ item.content }}
      <span
        class="choice-item-limit-tips"
        v-if="$store.getters?.getQuesInfo?.type === 1 && item.chance !== null"
        >{{ handleFormatlimitTips(item.chance) }}</span
      >
    </div>
  </Popup>
</template>

<script>
import { onMounted, ref, watchEffect } from 'vue'
import { Popup } from 'vant'
import { getAnswer, handleFormatlimitTips } from '@/utils/tools'
import '../choice/css/choice.scss'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    value: {
      type: String,
      default: '',
    },
    // 临时处理答题个人题型必填显示
    showAnswerRequired: {
      type: Number,
      default: 0,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Popup,
  },
  emits: ['selectCity'],
  setup(props, ctx) {
    const show = ref(false)
    const checkedValue = ref('点击选择')

    onMounted(() => {
      // 缓存值用的
      if (props.data.localChecked) {
      
        handleChoseClick({
          questionKey: props.data.questionKey,
          optionKey: props.data.localOptionKey,
          content: props.data.localChecked,
        })
        checkedValue.value = props.data.localChecked
      }

      //  本地缓存答案
      const localAnswer = getAnswer(props.data.questionKey)
      if (localAnswer) {
        checkedValue.value = localAnswer[0].answerContent

        handleChoseClick({
          questionKey: props.data.questionKey,
          optionKey: localAnswer[0].optionKey,
          content: localAnswer[0].answerContent,
        })
      }
    })

    /**
     * 点击展示区域选择弹框
     */
    const handleShowClick = () => {
      show.value = true
    }

    /**
     * 点击确定按钮
     */
    const handleChoseClick = (item) => {
      if (item.display === false) return
      checkedValue.value = item.content

      const question = {
        questionKey: item.questionKey,
        answers: [{
          questionKey: item.questionKey,
          optionKey: item.optionKey,
          answerContent: item.content,
        }],
        questionType: props.data.questionType,
      }

      ctx.emit('selectCity', question)
      show.value = false
    }

    /**
     * 点击取消按钮
     */
    const handleCancel = () => {
      show.value = false
    }

    return {
      show,
      handleFormatlimitTips,
      checkedValue,
      handleShowClick,
      handleChoseClick,
      handleCancel,
    }
  },
}
</script>
<style scoped>
.content-wrap {
  display: flex;
  justify-content: space-between;
}
.san {
  margin-right: 30px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #999;
}
.popup {
  box-sizing: border-box;
  padding-top: 20px;
  max-height: 50;
}
.select-item {
  box-sizing: border-box;
  padding: 30px;
  width: 100%;
  margin: 0 auto;
  border-bottom: 2px solid #f5f5f5;
  font-size: 32px;
  color: #333;
}
.disabled {
  color: #999;
  opacity: 0.7;
  cursor: not-allowed;
}
.select-item:last-child {
  border-bottom: none;
}
</style>
